import { ApiError, ErrorDetail } from '@/api'
import { useNotifications } from '@/components/ui/notifications'

// APIエラーレスポンスの型を拡張
interface ApiErrorWithBody extends ApiError {
  body: {
    errors?: Array<ErrorDetail>
  }
}

function isApiErrorWithErrors(error: unknown): error is ApiErrorWithBody {
  return (
    error !== null &&
    typeof error === 'object' &&
    'body' in error &&
    error.body !== null &&
    typeof error.body === 'object' &&
    'errors' in error.body &&
    Array.isArray((error as ApiErrorWithBody).body.errors)
  )
}

export const apiWrapper = async <T>(apiCall: Promise<{ data?: T | null }>): Promise<T> => {
  try {
    const res = await apiCall
    if (res && typeof res === 'object' && 'data' in res) {
      return res.data as T
    }
    return res as T
  } catch (error: unknown) {
    console.error('API error:', error)

    // エラーの型を安全にチェック
    if (isApiErrorWithErrors(error)) {
      const errors = error.body.errors
      if (errors) {
        errors.forEach((errorDetail) => {
          useNotifications.getState().addNotification({
            type: 'error',
            title: 'Error',
            message: errorDetail.message,
          })
        })
      }
    } else if (error instanceof Error) {
      // 一般的なエラーの場合
      useNotifications.getState().addNotification({
        type: 'error',
        title: 'Error',
        message: error.message || 'An unknown error occurred',
      })
    }

    throw error
  }
}
